import React from 'react'
import './index.sass'

export default function SuccessValidator({text}) {
    return (
        <div className='success-validator'>
            <img src={require('../../../assets/icons/tick.svg')} />
            <p>{text}</p>
        </div>
    )
}
